(function () {
  'use strict';

  var root = document.querySelector('[data-sm-dc]');
  if (!root) return;

  document.documentElement.classList.add('sm-dc-page');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var forms = root.querySelectorAll('[data-sm-dc-form]');
  var sticky = root.querySelector('[data-sm-dc-sticky]');
  var heroCard = root.querySelector('[data-sm-dc-buy]');

  function setBusy(form, busy) {
    var button = form.querySelector('[data-sm-dc-submit]');
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
    var label = button.querySelector('[data-sm-dc-submit-label]');
    if (label) {
      if (busy && !label.dataset.original) label.dataset.original = label.textContent;
      label.textContent = busy ? 'Adding…' : label.dataset.original || label.textContent;
    }
  }

  function openCart() {
    try {
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.setTimeout(function () {
          window.SLIDECART_OPEN();
        }, 250);
      }
    } catch (err) {
      /* SlideCart optional */
    }
  }

  function addToCart(form) {
    var data = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          var message = payload.description || payload.message || 'Unable to add membership to cart.';
          throw new Error(message);
        }
        return payload;
      });
    });
  }

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      setBusy(form, true);

      addToCart(form)
        .then(function () {
          openCart();
        })
        .catch(function (error) {
          window.alert(error.message);
        })
        .then(function () {
          form.dataset.submitting = 'false';
          setBusy(form, false);
        });
    });
  });

  if (sticky && heroCard && 'IntersectionObserver' in window) {
    var seenBuy = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) seenBuy = true;
          sticky.classList.toggle('is-visible', seenBuy && !entry.isIntersecting);
        });
      },
      { rootMargin: '-80px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(heroCard);
  }

  if (!reduceMotion) {
    var revealEls = root.querySelectorAll('[data-sm-dc-reveal]');
    if (revealEls.length && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      revealEls.forEach(function (el) {
        revealObserver.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-in');
      });
    }
  } else {
    root.querySelectorAll('[data-sm-dc-reveal]').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  var marquees = document.querySelectorAll('[data-sm-dc-marquee]');
  if (!reduceMotion && marquees.length && 'IntersectionObserver' in window) {
    var marqueeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-paused', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    marquees.forEach(function (el) {
      marqueeObserver.observe(el);
    });
  }
})();
